export enum ContentType {
  jpeg = 'image/jpeg',
  png = 'image/png',
  gif = 'image/gif',
  pdf = 'application/pdf',
  doc = 'application/msword',
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  odt = 'application/vnd.oasis.opendocument.text',
  xls = 'application/vnd.ms-excel',
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv = 'text/csv',
  dcm = 'application/dicom',
  xml = 'application/xml',
  zip = 'application/zip',
  json = 'application/json',
  ogg = 'audio/ogg',
  mp4 = 'video/mp4',
  vcf = 'text/vcard',
  webp = 'image/webp',
}

const contentTypes = Object.values(ContentType);

export enum Extension {
  jpeg = 'jpeg',
  png = 'png',
  gif = 'gif',
  pdf = 'pdf',
  doc = 'doc',
  docx = 'docx',
  odt = 'odt',
  xls = 'xls',
  xlsx = 'xlsx',
  csv = 'csv',
  dcm = 'dcm',
  xml = 'xml',
  zip = 'zip',
  ogg = 'ogg',
  mp4 = 'mp4',
  vcf = 'vcf',
  webp = 'webp',
  json = 'json',
}

// creating mime-type map because clinical types are not included in libraries
export const allowedExtensionTypeMap: Partial<Record<ContentType, Extension>> =
  {
    [ContentType.jpeg]: Extension.jpeg,
    [ContentType.png]: Extension.png,
    [ContentType.gif]: Extension.gif,
    [ContentType.pdf]: Extension.pdf,
    [ContentType.doc]: Extension.doc,
    [ContentType.docx]: Extension.docx,
    [ContentType.odt]: Extension.odt,
    [ContentType.xls]: Extension.xls,
    [ContentType.xlsx]: Extension.xlsx,
    [ContentType.csv]: Extension.csv,
    [ContentType.dcm]: Extension.dcm,
    [ContentType.ogg]: Extension.ogg,
    [ContentType.mp4]: Extension.mp4,
    [ContentType.vcf]: Extension.vcf,
    [ContentType.webp]: Extension.webp,
  };

export const allowedContentTypes: ContentType[] = Object.keys(
  allowedExtensionTypeMap,
) as ContentType[];

export const allowedExtensions: Extension[] = Object.values(
  allowedExtensionTypeMap,
);

//TODO: We should create a better differentiation between allowed media extensions and allowed document extensions
export const allowedDocumentExtensions: Extension[] = [
  Extension.csv,
  Extension.dcm,
  Extension.doc,
  Extension.docx,
  Extension.json,
  Extension.odt,
  Extension.pdf,
  Extension.xls,
  Extension.xlsx,
  Extension.xml,
];

export const getContentType = (
  contentType?: string,
): ContentType | undefined => {
  if (!contentType) {
    return undefined;
  }

  const foundType = contentTypes.find((type) => contentType === type);

  return foundType;
};

export const ContentTypeMap: Record<string, ContentType> = {
  'image/jpeg': ContentType.jpeg,
  'image/png': ContentType.png,
  'application/pdf': ContentType.pdf,
  'application/msword': ContentType.doc,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    ContentType.docx,
  'application/vnd.oasis.opendocument.text': ContentType.odt,
  'application/vnd.ms-excel': ContentType.xls,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    ContentType.xlsx,
  'text/csv': ContentType.csv,
  'application/dicom': ContentType.dcm,
  'application/xml': ContentType.xml,
  'application/zip': ContentType.zip,
  'application/json': ContentType.json,
  'audio/ogg': ContentType.ogg,
  'video/mp4': ContentType.mp4,
  'text/vcard': ContentType.vcf,
  'image/webp': ContentType.webp,
};

export const ExtensionContentTypeMap: Record<Extension, ContentType> = {
  [Extension.jpeg]: ContentType.jpeg,
  [Extension.png]: ContentType.png,
  [Extension.gif]: ContentType.gif,
  [Extension.pdf]: ContentType.pdf,
  [Extension.doc]: ContentType.doc,
  [Extension.docx]: ContentType.docx,
  [Extension.odt]: ContentType.odt,
  [Extension.xls]: ContentType.xls,
  [Extension.xlsx]: ContentType.xlsx,
  [Extension.csv]: ContentType.csv,
  [Extension.dcm]: ContentType.dcm,
  [Extension.xml]: ContentType.xml,
  [Extension.zip]: ContentType.zip,
  [Extension.json]: ContentType.json,
  [Extension.ogg]: ContentType.ogg,
  [Extension.mp4]: ContentType.mp4,
  [Extension.vcf]: ContentType.vcf,
  [Extension.webp]: ContentType.webp,
};
